import { isMockMode, post, simulateDelay } from "../api";

export const updateUserTags = ({ successMessage, ...data }) => {
	if (isMockMode()) {
		const testData = { success: true };
		return simulateDelay(1000, () => testData);
	}

	return post(`Users/UpdateTags`, data, {
		successMessage: successMessage || "Successfully edited tags",
	});
};
